/**
 * Crops an image (given as a dataURL) to the specified rectangle in image-space coordinates.
 * Returns a new dataURL of the cropped region.
 */
export function cropImage(
  src: string,
  cropRect: { x: number; y: number; w: number; h: number }
): Promise<string> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onerror = () => reject(new Error('Failed to load image for cropping'));
    img.onload = () => {
      const canvas = document.createElement('canvas');
      canvas.width = Math.round(cropRect.w);
      canvas.height = Math.round(cropRect.h);
      const ctx = canvas.getContext('2d');
      if (!ctx) {
        reject(new Error('Could not get canvas context'));
        return;
      }
      ctx.drawImage(
        img,
        Math.round(cropRect.x),
        Math.round(cropRect.y),
        Math.round(cropRect.w),
        Math.round(cropRect.h),
        0,
        0,
        Math.round(cropRect.w),
        Math.round(cropRect.h)
      );
      resolve(canvas.toDataURL('image/jpeg', 0.85));
    };
    img.src = src;
  });
}
